import React, { useState } from 'react';
import { CreateHabiHabitRequest } from '../../../api/habiApi';
import styles from './CreateHabiHabitModal.module.css';

interface CreateHabiHabitModalProps {
  selectedDate: string;
  onClose: () => void;
  onCreate: (req: CreateHabiHabitRequest) => Promise<void>;
}

const CreateHabiHabitModal: React.FC<CreateHabiHabitModalProps> = ({
  selectedDate,
  onClose,
  onCreate
}) => {
  const [title, setTitle] = useState('');
  const [isDaily, setIsDaily] = useState(true);
  const [scheduledDate, setScheduledDate] = useState(selectedDate);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    const t = title.trim();
    if (!t) {
      setError('Введите название');
      return;
    }
    if (!isDaily && !scheduledDate) {
      setError('Укажите дату для одноразового дела');
      return;
    }
    setSubmitting(true);
    try {
      await onCreate({
        title: t,
        isDaily,
        scheduledDate: isDaily ? null : scheduledDate
      });
      onClose();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Ошибка сохранения');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <h2>Добавить дело</h2>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Закрыть">
            <i className="ri-close-line" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className={styles.form}>
          <label className={styles.label}>
            Название
            <input
              type="text"
              value={title}
              onChange={e => setTitle(e.target.value)}
              placeholder="Например: Утренняя зарядка"
              className={styles.input}
              autoFocus
            />
          </label>

          <label className={styles.checkLabel}>
            <input
              type="checkbox"
              checked={isDaily}
              onChange={e => setIsDaily(e.target.checked)}
            />
            <span>Ежедневная привычка</span>
          </label>

          {!isDaily && (
            <label className={styles.label}>
              Дата
              <input
                type="date"
                value={scheduledDate}
                onChange={e => setScheduledDate(e.target.value)}
                className={styles.input}
              />
            </label>
          )}

          {error && <p className={styles.error}>{error}</p>}

          <div className={styles.actions}>
            <button type="button" className={styles.cancelBtn} onClick={onClose}>
              Отмена
            </button>
            <button type="submit" className={styles.submitBtn} disabled={submitting}>
              {submitting ? 'Сохранение...' : 'Добавить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateHabiHabitModal;
